var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.529297 8.17587C0.529297 3.95546 3.95518 0.528809 8.17636 0.528809C12.4052 0.528809 15.8234 3.95546 15.8234 8.17587C15.8234 12.3978 12.4052 15.8229 8.17636 15.8229C3.95518 15.8229 0.529297 12.3978 0.529297 8.17587ZM7.50362 5.27774C7.50362 4.91144 7.8095 4.60479 8.17656 4.60479C8.54362 4.60479 8.84185 4.91144 8.84185 5.27774V8.65774C8.84185 9.02556 8.54362 9.32303 8.17656 9.32303C7.8095 9.32303 7.50362 9.02556 7.50362 8.65774V5.27774ZM8.18403 11.7554C7.80932 11.7554 7.51109 11.4495 7.51109 11.0825C7.51109 10.7154 7.80932 10.4172 8.17638 10.4172C8.55109 10.4172 8.84932 10.7154 8.84932 11.0825C8.84932 11.4495 8.55109 11.7554 8.18403 11.7554Z",
    fill: "url(#paint0_linear_1680_627)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1680_627",
    x1: 8.17636,
    y1: 0.528809,
    x2: 8.17636,
    y2: 15.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917AFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.634604349ef80fcf7bfda1a7d181896d.svg";
export { ForwardRef as ReactComponent };